import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataSalesCreditRolesActions } from "./sales-credit-roles.actions";

// **************************************************************************
// SALES CREDIT ROLES REDUCER
// **************************************************************************

const load = on(DataSalesCreditRolesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        salesCreditRole: {
            ...state.data.salesCreditRole,
            salesCreditRolesLoading: true,
        },
    },
}));

const loadSuccess = on(DataSalesCreditRolesActions.loadSuccess, (state: ApplicationStore, { salesCreditRoles }) => ({
    ...state,
    data: {
        ...state.data,
        salesCreditRole: {
            ...state.data.salesCreditRole,
            salesCreditRoles,
            salesCreditRolesLoading: false,
        },
    },
}));

const loadFailure = on(DataSalesCreditRolesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        salesCreditRole: {
            ...state.data.salesCreditRole,
            salesCreditRolesLoading: false,
        },
    },
}));

export const salesCreditRolesReducer = [load, loadSuccess, loadFailure];
